import React from 'react';

const SavingsGoals = ({ account, onAddGoal, onAddFunds }) => {
    return (
        <div className="mt-4 space-y-3">
            <h4 className="text-sm font-semibold text-gray-600">Savings Goals</h4>
            {account.goals && account.goals.length > 0 ? (
                account.goals.map(goal => {
                    const progress = (goal.currentAmount / goal.targetAmount) * 100;
                    return (
                        <div key={goal.id} className="p-3 bg-white rounded-md border">
                            <div className="flex justify-between items-center text-sm mb-1">
                                <span className="font-medium">{goal.name}</span>
                                <span className="text-gray-500">${goal.currentAmount.toFixed(2)} / ${goal.targetAmount.toFixed(2)}</span>
                            </div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${progress}%` }}></div>
                            </div>
                            <button onClick={() => onAddFunds(account, goal)} className="text-xs text-blue-600 hover:underline mt-2">Add Funds</button>
                        </div>
                    )
                })
            ) : (
                <p className="text-sm text-gray-500">No goals set for this account.</p>
            )}
            <button onClick={() => onAddGoal(account.id)} className="w-full text-sm p-2 bg-blue-100 text-blue-800 rounded-md hover:bg-blue-200">+ Add New Goal</button>
        </div>
    );
};

export default SavingsGoals;